import {
  BuildingInfo,
  Device,
  LoginUser,
  Pico3,
  Sensor,
} from "01Data/DataTypes";
import { Model } from "99Tools/useModel";
import { CheckKizaiID, FormatDateISO } from "99Tools/utils";
import API from "./API";

export class Leakage {
  public kind: "sensor" | "pico3";
  public id: string;
  public LastLeaked: string;
  public ImageURL: string;
  public user: LoginUser;
  constructor(data: any, user: LoginUser) {
    this.kind = data?.kind ?? "sensor";
    this.id = data?.id ?? "";
    this.LastLeaked = data?.LastLeaked ?? "";
    this.ImageURL = data?.ImageURL ?? "";
    this.user = user;
  }
}

export class Devices extends Model {
  // 漏水ページデータ
  public leakages: Leakage[] = [];
  // デバイス一覧ページデータ
  public devices: Device[] = [];
  public errorMessage = "";
  public pageLeakage = 0;
  public rowsPerPageLeakage = 10;
  public pageID = 0;
  public rowsPerPageID = 10;
  public state: "ready" | "updating" = "ready";

  public SetError(err: any, msg: string) {
    this.errorMessage = msg;
    console.log(this.errorMessage);
    console.error(err);
  }

  public async GetDeviceData() {
    if (this.state === "updating") {
      return;
    }
    this.state = "updating";
    const data = await API.GetDeviceData();
    const accounts = data.users.map((item: any) => new LoginUser(item));
    const buildings = data.buildings.map((item: any) => new BuildingInfo(item));
    const sensors = data.sensors.map((item: any) => new Sensor(item));
    const pico3 = data.pico3.map((item: any) => new Pico3(item));
    this.leakages = [];
    this.devices = [];
    sensors.forEach((item: Sensor) => {
      const user = this.GetUser(item.BuildingId, buildings, accounts);
      if (item.LatestLog.SensorInfo === "LEAK") {
        this.leakages.push(
          new Leakage(
            {
              kind: "sensor",
              id: item.SensorId,
              LastLeaked: item.LastLeaked,
              ImageURL: item.SensorImage,
            },
            user
          )
        );
      }
      this.devices.push(
        new Device(
          {
            kind: CheckKizaiID(item.SensorId),
            id: item.SensorId,
            name: item.SensorName,
            StatusUpdatedAt: item.StatusUpdatedAt(),
            ComStatus: item.ComStatus,
            ImageURL: item.SensorImage,
          },
          user
        )
      );
    });
    pico3.forEach((item: Pico3) => {
      const user = this.GetUser(item.BuildingId, buildings, accounts);
      if (item.LatestLog.SensorInfo === "LEAK") {
        this.leakages.push(
          new Leakage(
            {
              kind: "pico3",
              id: item.PicoId,
              LastLeaked: item.LatestLog.ReceiveTime,
              ImageURL: item.PicoImage,
            },
            user
          )
        );
      }
      this.devices.push(
        new Device(
          {
            kind: "pico3",
            id: item.PicoId,
            name: item.PicoName,
            StatusUpdatedAt: item.StatusUpdatedAt(),
            ComStatus: item.ComStatus,
            ImageURL: item.PicoImage,
          },
          user
        )
      );
    });
    this.leakages = this.leakages.sort(
      (a: Leakage, b: Leakage) =>
        Date.parse(FormatDateISO(b.LastLeaked)) -
        Date.parse(FormatDateISO(a.LastLeaked))
    );
    this.state = "ready";
  }

  public GetUser(
    buildingId: string,
    buildings: BuildingInfo[],
    users: LoginUser[]
  ) {
    const buildingFound = buildings.find(
      (item: BuildingInfo) => buildingId === item.BuildingId
    );
    if (!buildingFound) {
      return new LoginUser(null); // 建物が見つからなかった
    }
    const user = users.find(
      (item: LoginUser) => buildingFound.UserId === item.UserId
    );
    if (user) {
      user.Email = buildingFound.Email;
      return user;
    } else {
      return new LoginUser(null);
    }
  }

  public async Update() {
    if (this.state === "updating") {
      return;
    }
    await this.GetDeviceData().catch((err: any) => {
      this.SetError(err, "デバイス自動更新に失敗しました。");
    });
    this.changed();
  }
}
